module.exports = __webpack_public_path__ + "img/icdeposit.edab4bc2.png";